module.exports = __webpack_public_path__ + "img/mentor.364ff5fb.png";